<template>

    <div class="loading-container">

		<div class="loading-inner-container">

			<div class="loading-animation-container">

				<div class="sk-cube-grid">
					<div class="sk-cube sk-cube1"></div>
					<div class="sk-cube sk-cube2"></div>
					<div class="sk-cube sk-cube3"></div>
					<div class="sk-cube sk-cube4"></div>
					<div class="sk-cube sk-cube5"></div>
					<div class="sk-cube sk-cube6"></div>
					<div class="sk-cube sk-cube7"></div>
					<div class="sk-cube sk-cube8"></div>
					<div class="sk-cube sk-cube9"></div>
				</div>

			</div>

			<div class="loading-text-container">
				{{ label }}
			</div>

		</div>

	</div>

</template>

<script>

	import Vue from 'vue';
	import { playerService } from '../player-service';

	export default Vue.component(
	  'loading',
	  {

		  name: 'loading',

		  /**
		   * This loader uses CSS animations from: http://tobiasahlin.com/spinkit/
		   * Head there to chanve the loader anim
		   */

		  data: function () {

			  return {}

		  },

		  props: {

			  label: {
				  required: true,
				  default: 'Loading - Please wait'
			  }

		  },

		  mounted: function () {



		  }

	  }
	);

</script>













